var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.6915 0 0 2.6915 0 6C0 9.3085 2.6915 12 6 12C9.3085 12 12 9.3085 12 6C12 2.6915 9.3085 0 6 0ZM5.9545 7.7095C5.761 7.903 5.5065 7.9995 5.251 7.9995C4.9955 7.9995 4.7385 7.902 4.543 7.707L3.152 6.359L3.8485 5.6405L5.245 6.994L8.1495 4.1435L8.8515 4.856L5.9545 7.7095Z",
    fill: "#00611B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.6915 0 0 2.6915 0 6C0 9.3085 2.6915 12 6 12C9.3085 12 12 9.3085 12 6C12 2.6915 9.3085 0 6 0ZM5.9545 7.7095C5.761 7.903 5.5065 7.9995 5.251 7.9995C4.9955 7.9995 4.7385 7.902 4.543 7.707L3.152 6.359L3.8485 5.6405L5.245 6.994L8.1495 4.1435L8.8515 4.856L5.9545 7.7095Z",
    fill: "#00611B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4ddbb86244752c141aa7e58774be7034.svg";
export { ForwardRef as ReactComponent };